export function getImagePath(
  imageJsonStr: string | null,
  resizeModel?: string,
  value?: number
) {
  const imgPathHost: string = process.env.VUE_APP_IMG_HOST;
  if (
    imageJsonStr &&
    imageJsonStr !== "" &&
    JSON.parse(imageJsonStr).length > 0
  ) {
    if (
      JSON.parse(imageJsonStr)[0].thumbServerPath &&
      JSON.parse(imageJsonStr)[0].thumbServerPath != ""
    ) {
      if (resizeModel && value && value > 0) {
        return (
          imgPathHost +
          JSON.parse(imageJsonStr)[0].thumbServerPath +
          "?x-oss-process=image/resize," +
          resizeModel +
          "_" +
          value
        );
      } else {
        return imgPathHost + JSON.parse(imageJsonStr)[0].thumbServerPath;
      }
    } else {
      if (resizeModel && value && value > 0) {
        return (
          imgPathHost +
          JSON.parse(imageJsonStr)[0].serverPath +
          "?x-oss-process=image/resize," +
          resizeModel +
          "_" +
          value
        );
      } else {
        return imgPathHost + JSON.parse(imageJsonStr)[0].serverPath;
      }
    }
  } else {
    return "";
  }
}

export function addImageHost(
  imageJson: any,
  resizeModel?: string,
  value?: number
) {
  const imgPathHost: string = process.env.VUE_APP_IMG_HOST;
  if (imageJson) {
    if (imageJson.thumbServerPath && imageJson.thumbServerPath != "") {
      if (resizeModel && value && value > 0) {
        return (
          imgPathHost +
          imageJson.thumbServerPath +
          "?x-oss-process=image/resize," +
          resizeModel +
          "_" +
          value
        );
      } else {
        return imgPathHost + imageJson.thumbServerPath;
      }
    } else {
      if (resizeModel && value && value > 0) {
        return (
          imgPathHost +
          imageJson.serverPath +
          "?x-oss-process=image/resize," +
          resizeModel +
          "_" +
          value
        );
      } else {
        return imgPathHost + imageJson.serverPath;
      }
    }
  } else {
    return "";
  }
}

function charString(char: string, count: number): string {
  let str = "";
  while (count--) {
    str += char;
  }
  return str;
}

export function dateFormat(dateStr: string, format?: string) {
  const date = new Date(dateStr);
  if (format == undefined) {
    format = "yyyy-MM-dd";
  }
  const map: any = {
    y: date.getFullYear() + "", //年份
    M: date.getMonth() + 1 + "", //月份
    d: date.getDate() + "", //日
    H: date.getHours(), //小时 24
    m: date.getMinutes() + "", //分
    s: date.getSeconds() + "", //秒
    q: Math.floor((date.getMonth() + 3) / 3) + "", //季度
    f: date.getMilliseconds() + "", //毫秒
  };

  const reg = "yMdHhmsqf";
  let all = "",
    str = "";
  for (let i = 0, n = 0; i < reg.length; i++) {
    n = format.indexOf(reg[i]);
    if (n < 0) {
      continue;
    }
    all = "";
    for (; n < format.length; n++) {
      if (format[n] != reg[i]) {
        break;
      }
      all += reg[i];
    }
    if (all.length > 0) {
      if (all.length == map[reg[i]].length) {
        str = map[reg[i]];
      } else if (all.length > map[reg[i]].length) {
        if (reg[i] == "f") {
          str = map[reg[i]] + charString("0", all.length - map[reg[i]].length);
        } else {
          str = charString("0", all.length - map[reg[i]].length) + map[reg[i]];
        }
      } else {
        switch (reg[i]) {
          case "y":
            str = map[reg[i]].substr(map[reg[i]].length - all.length);
            break;
          case "f":
            str = map[reg[i]].substr(0, all.length);
            break;
          default:
            str = map[reg[i]];
            break;
        }
      }
      format = format.replace(all, str);
    }
  }
  return format;
}

/**
 * 判断用户是否登录
 */
export function isLogin(): boolean {
  const token = sessionStorage.getItem("token");
  let userId: number;

  if (
    sessionStorage.getItem("userId") != null &&
    sessionStorage.getItem("userId") != ""
  ) {
    userId = Number(sessionStorage.getItem("userId"));
  } else {
    userId = 0;
  }

  if (token != null && token != "" && userId > 0) {
    return true;
  } else {
    return false;
  }
}
